import { render } from "./MyDocuments.vue?vue&type=template&id=e4a766bc&scoped=true"
import script from "./MyDocuments.vue?vue&type=script&lang=js"
export * from "./MyDocuments.vue?vue&type=script&lang=js"

import "./MyDocuments.vue?vue&type=style&index=0&id=e4a766bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a766bc"]])

export default __exports__